<div class="flex items-center justify-center dialog-header ">
    User Profile

    <div class="absolute right-2">
        <button
            (click)="handleCloseDialog()"
            class="outline-none p-5"
        >
            <i class="pi pi-times"></i>
        </button>
    </div>

</div>
<div class="dialog-content">
    <div>
        <div class="row">
            <div class="col-md-12">
                <form #userForm="ngForm">
                    <p-fieldset legend="User Details">
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-5 mt-3">
                            <div class="flex flex-col">
                                <label class="font-medium">Prefix</label>
                                <p-select
                                class="no-shadow-select"
                                [options]="prefixOptions" [(ngModel)]="user.prefix" name="prefix" #prefix="ngModel" required></p-select>
                                <div *ngIf="prefix.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="prefix.errors['required']">Prefix is required</div>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">First Name</label>
                                <input pInputText type="text" required [(ngModel)]="user.fname" name="fname" #fname="ngModel"
                                     class="border p-2 rounded-md no-shadow-input">
                                <div *ngIf="fname.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="fname.errors['required']">First Name is required</div>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Last Name</label>
                                <input pInputText type="text" required [(ngModel)]="user.lname" name="lname" #lname="ngModel"
                                     class="border p-2 rounded-md no-shadow-input">
                                <div *ngIf="lname.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="lname.errors['required']">Last Name is required</div>
                                </div>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Gender</label>
                                <p-select [options]="genderOptions" 
                                class="no-shadow-select"
                                [(ngModel)]="user.gender" name="gender" #gender="ngModel" required></p-select>
                                <div *ngIf="gender.errors && isSubmitted" class="text-red-500 text-sm">
                                    <div *ngIf="gender.errors['required']">Gender is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5">
                            <div class="font-medium mb-2" style="margin-bottom: 5px;">Professional Details</div>
                            <textarea pTextarea [(ngModel)]="user.details" name="profile" #profile="ngModel"
                                class="w-full border p-2 rounded-md"></textarea>
                        </div>
                    </p-fieldset>

                    <p-fieldset legend="Account Details">
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mt-3">
                            <div class="flex flex-col">
                                <label class="font-medium">Department</label>
                                <p-select id="department"  class="no-shadow-select" [options]="departmentsList" optionLabel="label" optionValue="value"
                                
                                    [(ngModel)]="user.dept_id" name="dept_id"  placeholder="Select Department" >
                                </p-select>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Role</label>
                                <p-select id="role"
                                class="no-shadow-select"
                                [options]="roles" optionLabel="name" optionValue="role_id"
                                    [(ngModel)]="user.role_id" name="role_id" placeholder="Select Role" >
                                </p-select>
                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Status</label>
                                <p-select 
                                class="no-shadow-select"
                                id="status" [options]="[{ label: 'Active', value: 'Active' }, { label: 'Inactive', value: 'Inactive' }]"
                                    [(ngModel)]="user.status" name="status" placeholder="Select Status" >
                                </p-select>
                            </div>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mt-5">
                            <div class="flex flex-col">
                                <label class="font-medium">Username</label>
                                <input
                                class="no-shadow-input"
                                pInputText  id="username" [(ngModel)]="user.username" name="username" 
                                [disabled]="true"
                                />
                               
                            </div>
                            <div class="flex flex-col">
                                <label class="font-medium">Email</label>
                                <input pInputText id="email"
                                class="no-shadow-input"
                                [(ngModel)]="user.email" name="email"  [disabled]="true"/>
                            </div>
                            <!-- <div class="flex flex-col">
                                <label class="font-medium">Password</label>
                                <p-password id="password"
                                class="rounded-none"
                                [(ngModel)]="user.password" name="password" [disabled]="true" placeholder="Password" [feedback]="false" [toggleMask]="true"></p-password>
                            </div> -->
                            <div class="flex flex-col">
                                <label class="font-medium">Two Factor Authentication</label>
                                <p-select id="twoFactorAuthentication" [options]="[{ label: 'Active', value: true }, { label: 'Inactive', value: false }]"
                                class="no-shadow-select"
                                    [(ngModel)]="user.twoFactorAuthentication" name="twoFactorAuthentication" placeholder="Select Two Factor Authentication" >
                                </p-select>
                            </div>
                        </div>
                    </p-fieldset>

                    <p-fieldset legend="Signature">
                        <button pButton type="button" label="Create New Signature" class="mt-3" (click)="openSignatureModal()"></button>
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-5">
                            <div *ngFor="let signature of signatures; let i = index" class="w-full">
                                <p-card class="w-full flex flex-col bordered-card">
                                    <p [innerHTML]="signature"></p>
                                    <div class="flex justify-between mt-2">
                                        <div>
                                            <p-radioButton name="signature" [value]="i" [(ngModel)]="selectedIndex"></p-radioButton>
                                        </div>
                                        <div class="flex gap-3">
                                        <button pButton label="Edit" class="p-button-sm" (click)="EditSignatureModal(i)"></button>
                                        <button pButton label="Delete" class="p-button-sm p-button-danger" (click)="deleteSignature(i)"></button>
                                    </div>
                                    </div>
                                </p-card>
                            </div>
                        </div>
                    </p-fieldset>
                    
                </form>
            </div>
        </div>
    </div>
    <div class="modal-footer mt-5 flex items-center gap-4">
        <button pButton type="button" label="Submit" icon="pi pi-save" [disabled]="isLoading"
            [loading]="isLoading"
            (click)="saveUser(userForm.form.valid)"></button>
        <button pButton  label="Close"
        (click)="handleCloseDialog()"
        class="p-button-secondary"></button>
    </div>
</div>


<p-dialog [modal]="true" [(visible)]="showSignatureModal"  [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false"
[style]="{ width: '50vw' }"
appendTo="body"
[draggable]="true" [resizable]="true">
    <app-signature-model (closeDialog)="handleCloseSignatureModel()"
    (updateSignatures)="updateSignaturesData($event)"
    (editSignatureValue)="editSignatureValue($event)"
    [signatureDataToEdit]="signatureDataToEdit"
    [singatureAction]="singatureAction"
    ></app-signature-model>
</p-dialog>